import React from 'react';

import PropTypes from 'prop-types';
import Stepper from 'react-stepper-horizontal';

import './Wizard.less';

const Direction = {
  Next: 'Next',
  Previous: 'Previous',
};

function Wizard({step, activeStep}) {
  return (
    <div className="cleaning-wizard">
      <Stepper
        steps={step}
        barStyle="solid"
        activeStep={activeStep}
        activeColor="#F7A246"
        activeTitleColor="#F7A246"
        activeBorderStyle="#CE873A"
        completeTitleColor="#3F9243"
        completeColor="#4CAF50"
        completeBarColor="#3F9243"
        completeBorderStyle="#3F9243"
        defaultColor="#E0E0E0"
        defaultBorderStyle="#CACACA"
        titleFontSize={16}
        circleFontSize={20}
        lineMarginOffset={0}
      />
      {step[activeStep].content}
    </div>
  );
}

Wizard.propTypes = {
  step: PropTypes.any,
  activeStep: PropTypes.any,
};

Wizard.defaultProps = {
  step: null,
  activeStep: null,
};

export default Wizard;

Wizard.Direction = {
  Next: Direction.Next,
  Previous: Direction.Previous,
};
